import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import { ToastProvider } from '@/design-system/Toast'
import { TooltipProvider } from '@/design-system/Tooltip'
import { Spinner } from '@/design-system/Spinner'
import { ThemeProvider } from '@/lib/theme/ThemeProvider'

/* ------------------------------------------------------------------ */
/*  App — root component                                                */
/*  Renders RouterProvider with global Suspense fallback (brand splash) */
/*  See ARCHITECTURE.md §3                                              */
/* ------------------------------------------------------------------ */

function BrandSplash() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-neutral-50">
      <h1 className="font-display text-display-md text-primary-700">Hjälptorget</h1>
      <Spinner size={24} />
    </div>
  )
}

export default function App() {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <ToastProvider>
          <Suspense fallback={<BrandSplash />}>
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
          </Suspense>
        </ToastProvider>
      </TooltipProvider>
    </ThemeProvider>
  )
}
